<template>
  <div>
    <customer-detail v-if="customerID || customerID == 0">
      <span v-if="isResidential">Account Holder</span>
      <span v-if="!isResidential">Authorised Representative</span>
    </customer-detail>
    <customer-address
      v-if="customerID > 0"
      :add="false"
      @added="added"
    ></customer-address>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import CustomerDetail from '@/components/customer-detail';

import { mapCustomerFields } from '../store/modules/orders';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);

export default {
  components: {
    CustomerDetail,
  },
  data() {
    return {
      isDataLoading: true,
    };
  },
  computed: {
    ...mapCustomerFields(['customer.customerID']),
    ...mapOrderState([
      'auth',
      'message',
      'isResidential',
      'rows',
      'address',
      'company',
      'customer',
      'dealer',
      'landline',
      'newChurn',
    ]),
  },
  methods: {
    added(val) {
      if (val) {
        this.$router.push(val);
      }
    },
  },
};
</script>
